"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBodyText = exports.ButtonStyled = void 0;
var colors_1 = require("../../../v2/themes/colors");
var mixins_1 = require("../../../themes/mixins");
var getDynamicColors_1 = require("../../themes/utils/getDynamicColors");
var styled_components_1 = __importStar(require("styled-components"));
var Typo2_1 = require("../Typo2");
var baseStyling_1 = require("../../themes/utils/baseStyling");
var grey40 = colors_1.colors.grey40, grey10 = colors_1.colors.grey10, grey80 = colors_1.colors.grey80, primaryContainer = colors_1.colors.primaryContainer, onPrimary = colors_1.colors.onPrimary, secondaryContainer = colors_1.colors.secondaryContainer, onSecondary = colors_1.colors.onSecondary;
// Constants
var BUTTON_SIZES = {
    S: '3rem',
    M: '3.2rem',
};
var BUTTON_PADDING = {
    default: '0.9rem 1.2rem',
    iconWithText: '0.9rem 1.2rem 0.9rem 1rem',
    iconOnly: '0.9rem',
};
var BUTTON_PADDING_DF = {
    default: '1.2rem 1.4rem 1.2rem 1.6rem',
    iconWithText: '1.2rem 1.4rem 1.2rem 1.2rem',
    iconOnly: '1.2rem',
};
// Disabled States
var disabledStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  pointer-events: none;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  pointer-events: none;\n"])), grey10, grey40);
// Variant Styles
var variants = {
    primary: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    \n    ", "\n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    \n    ", "\n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "])), function (_a) {
        var colors = _a.theme.colors;
        return colors ? (0, getDynamicColors_1.getPrimaryContainer)(colors) : primaryContainer;
    }, function (_a) {
        var colors = _a.theme.colors;
        return colors ? (0, getDynamicColors_1.getOnPrimary)(colors) : onPrimary;
    }, function (_a) {
        var forceHover = _a.forceHover;
        return forceHover && (0, baseStyling_1.applyBlackOverlayOnHover)();
    }, function (_a) {
        var disabled = _a.disabled;
        return disabled && disabledStyles;
    }, (0, baseStyling_1.applyBlackOverlayOnHover)()),
    secondary: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    \n    ", "\n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    \n    ", "\n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "])), function (_a) {
        var colors = _a.theme.colors;
        return colors ? (0, getDynamicColors_1.getSecondaryContainer)(colors) : secondaryContainer;
    }, function (_a) {
        var colors = _a.theme.colors;
        return colors ? (0, getDynamicColors_1.getOnSecondary)(colors) : onSecondary;
    }, function (_a) {
        var disabled = _a.disabled;
        return disabled && disabledStyles;
    }, function (_a) {
        var forceHover = _a.forceHover;
        return forceHover && (0, baseStyling_1.applyBlackOverlayOnHover)();
    }, (0, baseStyling_1.applyBlackOverlayOnHover)()),
    tertiary: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: transparent;\n    color: ", ";\n    /* border: 1px solid ", "; */\n    box-sizing: border-box;\n    outline: 1px solid ", ";\n    ", "\n\n    ", "\n\n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "], ["\n    background-color: transparent;\n    color: ", ";\n    /* border: 1px solid ", "; */\n    box-sizing: border-box;\n    outline: 1px solid ", ";\n    ", "\n\n    ", "\n\n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "])), grey80, colors_1.colors.grey10, grey10, function (_a) {
        var disabled = _a.disabled;
        return disabled && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n      pointer-events: none;\n    "], ["\n      color: ", ";\n      pointer-events: none;\n    "])), grey40);
    }, function (_a) {
        var forceHover = _a.forceHover;
        return forceHover && (0, baseStyling_1.applyBlackOverlayOnHover)();
    }, (0, baseStyling_1.applyBlackOverlayOnHover)()),
    ghost: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    background-color: transparent;\n    color: ", ";\n\n    ", "\n    \n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "], ["\n    background-color: transparent;\n    color: ", ";\n\n    ", "\n    \n    ", "\n    \n    @media (hover: hover) {\n      &:hover {\n        ", "\n      }\n    }\n  "])), grey80, function (_a) {
        var disabled = _a.disabled;
        return disabled && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n      pointer-events: none;\n    "], ["\n      color: ", ";\n      pointer-events: none;\n    "])), grey40);
    }, function (_a) {
        var forceHover = _a.forceHover;
        return forceHover && (0, baseStyling_1.applyBlackOverlayOnHover)();
    }, (0, baseStyling_1.applyBlackOverlayOnHover)()),
};
// Composition Styles
var getCompositionStyles = function (composition, responsive) {
    switch (composition) {
        case 'iconOnly':
            return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        padding: ", "; \n        flex-shrink: 0;\n      "], ["\n        padding: ", "; \n        flex-shrink: 0;\n      "])), responsive ? BUTTON_PADDING_DF.iconOnly : BUTTON_PADDING.iconOnly);
        case 'icon+text':
            return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        padding: ", "; \n      "], ["\n        padding: ", "; \n      "])), responsive ? BUTTON_PADDING_DF.iconOnly : BUTTON_PADDING.iconOnly);
        default:
            return (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        padding: ", "; \n      "], ["\n        padding: ", "; \n      "])), responsive ? BUTTON_PADDING_DF.iconOnly : BUTTON_PADDING.iconOnly);
    }
};
// Main Button Component
exports.ButtonStyled = styled_components_1.default.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n  \n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  border: none;\n  border-radius: 6px;\n  position: relative;\n  overflow: hidden;\n\n  /* ", " */\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ", "\n  ", "\n\n  > * {\n    position: relative;\n    z-index: 2;\n  }\n"], ["\n  ", "\n  \n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  border: none;\n  border-radius: 6px;\n  position: relative;\n  overflow: hidden;\n\n  /* ", " */\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ", "\n  ", "\n\n  > * {\n    position: relative;\n    z-index: 2;\n  }\n"])), function (_a) {
    var _b = _a.composition, composition = _b === void 0 ? 'textOnly' : _b, responsive = _a.responsive;
    return getCompositionStyles(composition, responsive);
}, function (_a) {
    var width = _a.width, composition = _a.composition, size = _a.size;
    return width
        ? (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["width: ", ";"], ["width: ", ";"])), width) : (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      min-width: ", ";\n      max-width: 400px;\n    "], ["\n      min-width: ", ";\n      max-width: 400px;\n    "])), composition === 'iconOnly' ? BUTTON_SIZES[size] : '60px');
}, (0, mixins_1.transition)("background-color"), function (_a) {
    var variant = _a.variant;
    return variants[variant];
});
exports.StyledBodyText = (0, styled_components_1.default)(Typo2_1.UI_BODY_BOLD_SM)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), mixins_1.ellipsis);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
